import { render, staticRenderFns } from "./aside-navigation.vue?vue&type=template&id=6deead83&"
import script from "./aside-navigation.vue?vue&type=script&lang=js&"
export * from "./aside-navigation.vue?vue&type=script&lang=js&"
import style0 from "./aside-navigation.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports